'use strict';

var removeMarkdown = require('remove-markdown');

var buildSimpleValidator = require('./helpers/build-simple-validator');

module.exports = buildSimpleValidator(function (value, validationOptions) {
  return removeMarkdown(value).length >= validationOptions.minLength;
},
// eslint-disable-next-line max-len
function (value, validationOptions) {
  return 'This section has a minimum length of ' + validationOptions.minLength + ' characters. Add some content in order to complete this section.';
}, ['minLength']);